import { useState } from 'react';
import { Switch } from './ui/switch';
import { plansData } from '../data/mockData';

export const IDCardGenerator = () => {
  const [cardView, setCardView] = useState('Front');
  return (
    <div className="flex-1 h-full rounded-[32px] p-2 id-card-container overflow-y-auto max-lg:my-2.5">
      <div className="px-8 py-6 max-md:px-4 max-container">
        <h1 className="id-card-title font-medium max-lg:!text-2xl max-md:!text-xl">
          Generate Insurance ID Cards
        </h1>
        <p className="mt-2 id-card-subtitle max-md:!text-sm">
          Search member - see purchased plans - enter per-plan card data →
          preview and export.
        </p>
      </div>

      <div className="space-y-6 bg-white-overlay big-corner p-6 h-fit max-md:p-2 max-md:bg-transparent max-container">
        <div className="bg-white rounded-xl p-4 shadow-sm flex justify-between items-center max-lg:flex-col max-lg:items-baseline max-lg:gap-5">
          <div className="flex items-center gap-4">
            <span className="rounded-full w-8 h-8 flex items-center justify-center text-sm font-medium id-card-number">
              01
            </span>
            <h2 className="text-xl font-semibold">Search for member</h2>
          </div>
          <div className="flex gap-4 w-1/2 max-lg:w-full max-md:flex-col">
            <div className="flex-1 relative">
              <input
                type="text"
                placeholder="Search by name or member ID..."
                className="w-full px-4 py-3 pl-8 h-10 border rounded-lg focus:outline-none focus:ring-2 id-card-input"
              />
              <img
                src="/icons/Search.svg"
                alt="search"
                className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4"
              />
            </div>
            <button className="px-6 py-2 rounded-full bg-secondary-bg text-white">
              Search
            </button>
          </div>
        </div>
        <div className="flex gap-6 h-fit max-xl:flex-col">
          <div className="bg-white rounded-xl p-5 shadow-sm w-1/2 h-fit max-xl:w-full">
            <div className="flex items-center mb-6 gap-4">
              <span className="rounded-full w-8 h-8 flex items-center justify-center text-sm font-medium id-card-number">
                02
              </span>
              <h2 className="text-xl font-semibold">Member & Plans</h2>
            </div>

            <div className="flex flex-col gap-6">
              <div className="border-2 p-4 rounded-xl border-light">
                <h3 className="text-lg font-medium mb-4 id-card-subsection-title">
                  Member Information
                </h3>
                <div className="space-y-3 flex flex-col">
                  <div className="flex justify-between">
                    <span className="id-card-text text-sm">
                      Selected Member
                    </span>
                    <span className="text-sm">Jane Smith</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="id-card-text text-sm">Member ID</span>
                    <span className="text-sm">23432432</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="id-card-text text-sm">DOB</span>
                    <span className="text-sm">6/21/1990</span>
                  </div>
                </div>
              </div>

              <div className="flex flex-col border-2 p-3 rounded-xl border-light">
                <h3 className="text-lg font-medium mb-4">Plans Purchased</h3>
                <div className="flex flex-col gap-5">
                  {plansData.map((plan, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between"
                    >
                      <div className="flex gap-3">
                        <span className="id-card-text-dark">{plan.name}</span>
                        <div className="flex items-center space-x-2">
                          <span
                            className={`px-3 py-1 rounded-full text-xs text-white ${plan.statusClass}`}
                          >
                            {plan.status}
                          </span>
                        </div>
                      </div>
                      <a
                        href="#"
                        className="p-2 bg-light-gray-custom rounded-full"
                      >
                        <img
                          src="/icons/arrow-up.svg"
                          alt="arrow"
                          className="w-5 h-5"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-5 shadow-sm w-1/2 h-fit max-xl:w-full">
            <div className="flex items-center mb-4 gap-4">
              <span className="rounded-full w-8 h-8 flex items-center justify-center text-sm font-medium id-card-number">
                03
              </span>
              <h2 className="text-xl font-semibold">Enter Card Details</h2>
            </div>

            <div className="flex flex-col gap-4">
              <div className="flex flex-col border-2 gap-3 p-3 rounded-xl border-light">
                <h3 className="text-sm font-medium">Health ID Card</h3>
                <div className="space-y-4">
                  <div>
                    <input
                      type="text"
                      placeholder="Card number (10-20 digits)"
                      className="w-full px-4 py-3 border h-10 rounded-lg focus:outline-none focus:ring-2 id-card-input"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Group Number"
                      className="w-full px-4 py-3 border h-10 rounded-lg focus:outline-none focus:ring-2 id-card-input"
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col border-2 gap-4 p-3 rounded-xl border-light">
                <h3 className="text-lg font-medium id-card-subsection-title">
                  Preview
                </h3>
                <div className="rounded-lg text-center id-card-border flex flex-col gap-4">
                  <img
                    src="/icons/preview.png"
                    alt="preview"
                    className="w-full h-auto"
                  />
                  <div className="flex justify-center">
                    <Switch
                      options={['Front', 'Back']}
                      selectedOption={cardView}
                      onOptionChange={setCardView}
                      className="w-full"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-4 gap-4 max-lg:flex-col">
              <a
                href=""
                className="px-6 w-full text-center py-2 font-medium rounded-full transition-colors bg-light-gray-custom max-lg:text-sm"
              >
                Download PNG
              </a>
              <a
                href=""
                className="px-6 w-full text-center py-2 font-medium rounded-full transition-colors bg-light-gray-custom max-lg:text-sm"
              >
                Download PDF
              </a>
              <a
                href=""
                className="px-6 w-full text-center py-2 font-medium rounded-full text-white transition-color bg-secondary-bg max-lg:text-sm"
              >
                Save Card
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDCardGenerator;
